import { render } from "./MyFindPasswd.vue?vue&type=template&id=093fdd5c"
import script from "./MyFindPasswd.vue?vue&type=script&lang=js"
export * from "./MyFindPasswd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__